import './ChatCTA.scss'

import { Col, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import { navigateTo } from 'components/common/navigation'
import RembleAvatar from '../../../assets/images/Remble_Logomark-Green-25pGreen.png'

/**
 * Chat CTA component. Used for displaying calls to action for the chat.
 */
export default function ChatCTA({
  message = 'Hello, there. How can I help you today?',
  uri = null,
  className = '',
  asLink = false
}) {
  const history = useHistory()

  /**
   * Handle the click event
   */
  const handleClick = () => {
    // If we don't have a URI, return
    if (!uri) return

    navigateTo(uri, history)
  }

  return asLink ? (
    <span className={`chat-cta-link ${className}`} onClick={handleClick}>
      <img src={RembleAvatar} alt='' width='20' />
      {message}
    </span>
  ) : (
    <div className={`chat-cta ${className}`} onClick={handleClick}>
      <Row className='prompt'>
        <Col xs={4} md={7} lg={5} className='p-0 text-right avatar'>
          <img src={RembleAvatar} alt='' width='20' />
        </Col>
        <Col className='p-0 message' xs={8} md={5} lg={7}>
          <p>{message}</p>
        </Col>
      </Row>
    </div>
  )
}
